import { render, staticRenderFns } from "./fork_info.vue?vue&type=template&id=2c6b4d16"
import script from "./fork_info.vue?vue&type=script&lang=js"
export * from "./fork_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports